import { render } from "./CanxuanCommodityAll.vue?vue&type=template&id=e666f4c0"
import script from "./CanxuanCommodityAll.vue?vue&type=script&lang=js"
export * from "./CanxuanCommodityAll.vue?vue&type=script&lang=js"

import "./CanxuanCommodityAll.vue?vue&type=style&index=0&id=e666f4c0&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__